import React, { useEffect,  useState } from "react";
import axios from "axios"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css";
import { FaQuoteLeft } from "react-icons/fa";


const Testimonials = () => {
  const [Testimonial, setTestimonials] = useState([]);

  useEffect(() => {
    axios
      .get("https://www.isolsgroup.com/new/api/ApiTestimonial", {
        headers: {
          "X-API-KEY": "ISOLS", // 🔐 Replace with your actual key if required
        },
        params: { // sends ?category_id=5
          homepage_feedback: 1
        }
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          // ✅ Limit to only first 4 records
          const homepagetestimonials = response.data.data
            .filter((item) => item.homepage_feedback === "1" || item.homepage_feedback === 1)
            .slice(0, 4);
          setTestimonials(homepagetestimonials);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching brand data:", error);
      });
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, 
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: true,
  };

  // ✅ Helper function to remove HTML tags from description
  const stripTags = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  return (
    <section className="clientfeedback">
      <div className="container">
        <div className="row b-member-info">
          <div className="col-xs-12 col-sm-3">
            <div className="b-mod-heading">
              <p className="first-heading font-secondary member-prof">Clients' </p>
              <h4 className="heading-line line-right customColor customPseudoElBg member-name">
                <strong>Feedback</strong>
              </h4>
            </div>
          </div>
          <div className="col-xs-12 col-sm-9">
            <div className="b-member-caption">
              <h6 className="contact-info-title customPseudoElBg font-secondary">
                Our satisfaction is directly proportional to client happiness
              </h6>
              <p>ISOLS Group has been awarded as the Best Technology and Digital Company 2021 Award by Topgallant Media.</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-12">
            {Testimonial.length > 0 ? (
            <Slider {...settings}>
              {Testimonial.map((feedback, index) => (
                <div key={index} className="clientfed">
                
                  <div className="clientdesc">
                  <span><FaQuoteLeft /> {" "}</span>
                    <p>{stripTags(feedback.description)}</p>
              
                  </div>
                  <div className="clientquote">
                    <img src={`https://www.isolsgroup.com/images/dummy.png`} alt={feedback.heading} width="100px" height="100px" />
                    <p className="quote-client">{feedback.heading}</p>
                  </div>
                </div>
              ))}
            </Slider>
            ) : (
            <p className="text-center mt-4">No Data available.</p>
            )}

          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
